import React from 'react';
import './style.less';

export const SpotlightToggleCard: React.FC<{ title: React.ReactNode }> = ({
  children,
  title,
}) => {
  return (
    <div className="SpotlightToggleCard">
      <div className="SpotlightToggleCard__header">{title}</div>
      <div className="SpotlightToggleCard__body">{children}</div>
    </div>
  );
};
